/**
 * Diary 사진/서류 허브
 *
 * BS 안에서 탭 네비게이션을 관리하고,
 * 본문 영역은 $j.Ui.Div.open()을 통해 각 모듈을 호출한다.
 *
 * [탭 구성]
 *   작업문서  → DiaryDocs
 *   현장사진  → DiaryJobs
 *
 * [호출]
 * $j.Ui.BS.open({
 *     target: '$j.F.Diary.DiaryPhotoHub',
 *     data: { ordernum }
 * });
 */
export default class DiaryPhotoHub {
    constructor() {
        this.TAB_CONFIG = [
            { key: 'doc',    module: '$j.F.Diary.DiaryDocs',    label: '작업문서',  title: '작업문서' },
            { key: 'photo',  module: '$j.F.Diary.DiaryJobs',    label: '현장사진',  title: '현장사진' },
        ];
        this.activeTab = null;
        this.contentDivId = null;
    }

    destroy() {
        $(`#${this.id}`).off();
        $(document).off('click.dphTabs');
        $('.bottomsheet-popup').removeClass('dph-bs');   // BS 는 단일 인스턴스 — 다른 시트에 여백 수정자가 남지 않게
    }

    init() {
        // 이 시트만 BS 기본 여백(좌우 20px · 헤더 아래 20px)을 걷는다 — 탭은 헤더 바로 아래, 좌우는 pane 이 16px (_diary-photo.scss)
        $('.bottomsheet-popup').addClass('dph-bs');
        const tabs = this._visibleTabs();
        const requestedTab = this.data?.tab || tabs[0]?.key || 'doc';
        this.contentDivId = `dph-content-${Math.random().toString(36).substring(2, 8)}`;

        this.draw(tabs);
        this.initHandler();
        this.switchTab(requestedTab);
    }

    _isMercury() {
        if (typeof ORDER === 'undefined') return false;
        const sosok = ORDER['order_sosok'] || '';  // 화물공제조합·KB손해보험
        return sosok.indexOf('022002') === 0 || sosok.indexOf('022003') === 0;
    }

    _visibleTabs() {
        const visible = this.data?.visibleTabs;
        if (Array.isArray(visible) && visible.length > 0) {
            return this.TAB_CONFIG.filter(t => visible.includes(t.key));
        }
        return this.TAB_CONFIG.slice();
    }

    _ordernum() {
        return this.data?.ordernum || (typeof ORDER !== 'undefined' ? ORDER['num'] : '');
    }

    // ─── 렌더링 ──────────────────────────────────

    /**
     * 탭(작업문서 | 현장사진)은 본문이 아니라 **헤더 제목 자리**에 그린다 — 닫기 X 와 같은 줄.
     * 본문 위에 두면 헤더 줄이 비고 탭 줄이 하나 더 생겨 상단이 깊어진다. 끌기 가드가 button 은 건너뛰므로 button 으로.
     */
    draw(tabs) {
        this._tabs = tabs;
        const html = `
        <div class="mc-hub-wrap mc-hub-no-tabs">
            <div class="mc-hub-content" id="${this.contentDivId}"></div>
        </div>`;
        $(`#${this.id}`).html(html);
    }

    _tabsHtml(activeKey) {
        if (!this._tabs || this._tabs.length < 2) return '';
        return '<span class="mc-tabs">' + this._tabs.map(t =>
            `<button type="button" class="mc-tab${t.key === activeKey ? ' active' : ''}" data-tab="${t.key}">${t.label}</button>`
        ).join('') + '</span>';
    }

    initHandler() {
        const self = this;
        // 탭은 헤더(컨테이너 밖)에 있어 문서에 위임한다 — destroy 가 뗀다
        $(document).off('click.dphTabs').on('click.dphTabs', '.bottomsheet-popup.dph-bs .mc-tab:not(.active)', function () {
            self.switchTab($(this).data('tab'));
        });
    }

    // ─── 탭 전환 ──────────────────────────────────

    switchTab(tabKey) {
        const tab = this.TAB_CONFIG.find(t => t.key === tabKey);
        if (!tab) return;

        this.activeTab = tabKey;

        // 헤더 제목 자리에 탭(활성 표시 포함). 탭이 하나면 그 이름을 제목으로
        this.parent.setTitle(this._tabsHtml(tabKey) || (tab.title || ''));

        // 뷰어 복귀시 상태 복원 데이터가 있으면 전달
        const divData = { ordernum: this._ordernum(), mercury: this._isMercury(), smode: this.data?.smode };
        if (this.data?.restoreState) {
            Object.assign(divData, this.data.restoreState);
            delete this.data.restoreState; // 1회만 사용
        }

        // 본문 영역에 모듈 로드
        $j.Ui.Div.open({
            id: this.contentDivId,
            target: tab.module,
            container: this,
            data: divData,
        });
    }
}
